import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { dispatcher } from 'dispatcher';

import * as actions from '../store/actions';

export const useAddTranslations = () => {
    const i18nDispatch = useDispatch();

    return useCallback(({
        translations,
        isPageTranslations,
        isPageInPopupTranslations
    }: {
        translations: Record<string, string>,
        isPageTranslations: boolean,
        isPageInPopupTranslations: boolean
    }): void => {
        if (isPageTranslations && !isPageInPopupTranslations) {
            dispatcher.dispatch('i18n:page:translations', translations);
        } else if (isPageInPopupTranslations) {
            dispatcher.dispatch('i18n:pageInPopup:translations', translations);
        } else {
            dispatcher.dispatch('i18n:system:translations', translations);
        }

        i18nDispatch(actions.addTranslationsAction(translations));
    }, [i18nDispatch]);
};
